

/* tslint:disable */



export enum ObservationPermittedDataType {
    Quantity = 0,
    CodeableConcept = 1,
    Boolean = 3,
    Integer = 4,
    Ratio = 6,

}


